import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PersonPage from "./pages/PersonPage";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminCarousel from "./admin/AdminCarousel";
import AdminMedia from "./admin/AdminMedia";
import AdminContributions from "./admin/AdminContributions";
import AdminPersons from "./admin/AdminPersons";
import PersonPublicForm from "./pages/PersonPublicForm";
import AdminSettings from "./admin/AdminSettings";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
 
          <Route path="/p/:slug" element={<PersonPublicForm />} />
        {/* Admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="persons" element={<AdminPersons />} />
          <Route path="contributions" element={<AdminContributions />} />
          <Route path="carousel" element={<AdminCarousel />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="settings" element={<AdminSettings />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
}
